<script>
import { addClass, hasClass } from 'element-ui/src/utils/dom';
import ElFormItem from 'element-ui/packages/form-item';
export default {
  name: 'FormItem',
  extends: ElFormItem,
  props: {
    wrap: Boolean,
    fill: [Number, String],
    noHover: Boolean
  },
  computed: {
    sizeClass() {
      let fillClass = this.fill ? ` fill-${this.fill}` : '';
      let hoverClass = this.noHover ? '' : ' hover';
      let jyClass = ' col-jy' + fillClass + hoverClass;

      return (this.elFormItemSize || (this.$ELEMENT || {}).size) + jyClass;
    }
  },
  watch: {
    wrap() {
      this.initWrap();
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initWrap();
      }, 100);
    });
  },
  beforeDestroy () {
    if (this.$el && this.$el.parentNode) {
      let wraps = this.$el.parentNode.querySelectorAll('.col-wrap') || [];
      wraps.forEach(d => {
        this.$el.parentNode.removeChild(d);
      });
    }
  },
  methods: {
    initWrap() {
      let $el = this.$el;
      let wrap = $el.previousSbiling;
      if (this.wrap) {
        if (!wrap || !hasClass(wrap, 'col-wrap')) {
          wrap = document.createElement('div');
          addClass(wrap, 'w-100 col-wrap');
          $el.parentNode.insertBefore(wrap, $el);
        }
      } else {
        if (wrap && hasClass(wrap, 'col-wrap')) {
          $el.parentNode.removeChild(wrap);
        }
      }
    }
  }
};
</script>
<style>
@media (min-width: 576px) {
  
}
</style>